import React, { useEffect, useState } from 'react';
import { defineMessages } from 'react-intl';
import CropImageField from '@components/common/form/CropImageField';
import { AppConstants } from '@constants';
import apiConfig from '@constants/apiConfig';
import { commonStatus, statusOptions } from '@constants/masterData';
import useBasicForm from '@hooks/useBasicForm';
import useFetch from '@hooks/useFetch';
import useTranslate from '@hooks/useTranslate';
import { BaseForm, SelectField, TextField } from '@itz/react-cms-element';
import { commonMessage } from '@locales/intl';
import { Card, Col, Form, Row } from 'antd';

const message = defineMessages({
    objectName: 'Customer',
});

const CustomerForm = (props) => {
    const translate = useTranslate();
    const { formId, actions, dataDetail, onSubmit, setIsChangedFormValues, branchs, isEditing } = props;
    const [ imageUrl, setImageUrl ] = useState(null);
    const statusValues = translate.formatKeys(statusOptions, ['label']);

    const { form, mixinFuncs, onValuesChange } = useBasicForm({
        onSubmit,
        setIsChangedFormValues,
    });

    const handleSubmit = (values) => {
        return mixinFuncs.handleSubmit({
            ...values,
        });
    };

    useEffect(() => {
        form.setFieldsValue({
            ...dataDetail,
        });
        setImageUrl(dataDetail?.logoPath);
    }, [ dataDetail ]);
    return (
        <BaseForm id={formId} onFinish={handleSubmit} form={form} onValuesChange={onValuesChange}>
            <Card className="card-form" bordered={false}>
                <Row gutter={16}>
                    <Col span={12}>
                        <TextField
                            required
                            disabled
                            label={translate.formatMessage(commonMessage.username)}
                            name="userUsername"
                            autoComplete="off"
                        />
                    </Col>
                    <Col span={12}>
                        <TextField
                            required
                            disabled
                            label={translate.formatMessage(commonMessage.fullName)}
                            name="userName"
                        />
                    </Col>
                </Row>

                <Row gutter={16}>
                    <Col span={12}>
                        <TextField
                            disabled
                            label={translate.formatMessage(commonMessage.namePrefix)}
                            name="phone"
                        />
                    </Col>
                    <Col span={12}>
                        <TextField
                            required
                            disabled
                            label={translate.formatMessage(commonMessage.email)}
                            name="userEmail"
                            type="email"
                            autoComplete="off"
                            rules={[{ type: 'email', message: translate.formatMessage(commonMessage.invalidEmail) }]}
                        />
                    </Col>
                </Row>

                <Row gutter={16}>
                    <Col span={12}>
                        <TextField
                            label={translate.formatMessage(commonMessage.newPassword)}
                            required={!isEditing}
                            name="password"
                            type="password"
                            autoComplete="new-password"
                            rules={[
                                {
                                    validator: async () => {
                                        const isTouched = form.isFieldTouched('password');
                                        if (isTouched) {
                                            const value = form.getFieldValue('password');
                                            if (value.length < 6) {
                                                throw new Error(
                                                    translate.formatMessage(commonMessage.validatePassword),
                                                );
                                            }
                                        }
                                    },
                                },
                            ]}
                        />
                    </Col>
                    <Col span={12}>
                        <TextField
                            label={translate.formatMessage(commonMessage.confirmNewPassword)}
                            required={!isEditing}
                            name="confirmPassword"
                            type="password"
                            autoComplete="new-password"
                            rules={[
                                {
                                    validator: async () => {
                                        const password = form.getFieldValue('password');
                                        const confirmPassword = form.getFieldValue('confirmPassword');
                                        if (password !== confirmPassword) {
                                            throw new Error(translate.formatMessage(commonMessage.passwordNotMatch));
                                        }
                                    },
                                },
                            ]}
                        />
                    </Col>
                </Row>

                <Row gutter={16}>
                    <Col span={12}>
                        <TextField label={translate.formatMessage(commonMessage.postCode)} name="postCode" disabled />
                    </Col>
                    <Col span={12}>
                        <TextField label={translate.formatMessage(commonMessage.city)} name="city" disabled />
                    </Col>
                </Row>

                <Row gutter={16}>
                    <Col span={12}>
                        <TextField label={translate.formatMessage(commonMessage.ward)} name="ward" disabled />
                    </Col>
                    <Col span={12}>
                        <TextField
                            label={translate.formatMessage(commonMessage.addressNumber)}
                            name="addressNumber"
                            disabled
                        />
                    </Col>
                </Row>
                <Row gutter={16}>
                    <Col span={12}>
                        <TextField label={translate.formatMessage(commonMessage.street)} name="street" disabled />
                    </Col>
                    <Col span={12}>
                        <TextField
                            label={translate.formatMessage(commonMessage.addressNote)}
                            name="addressNote"
                            disabled
                        />
                    </Col>
                </Row>
                <Row gutter={16}>
                    <Col span={12}>
                        <SelectField
                            label={translate.formatMessage(commonMessage.status)}
                            name="status"
                            required
                            options={statusValues}
                            initialValue={statusValues[0].value}
                        />
                    </Col>
                    <Col span={12}>
                        <Form.Item hidden initialValue={1}>
                            <input type="hidden" />
                        </Form.Item>
                    </Col>
                </Row>
                <div className="footer-card-form">{actions}</div>
            </Card>
        </BaseForm>
    );
};

export default CustomerForm;
